var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "flex-wrap": "wrap", width: "100%" },
        },
        [
          _vm.guidanceData.length == 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    width: "100%",
                    height: "100%",
                  },
                },
                [_c("el-empty", { attrs: { description: "暂无指引任务" } })],
                1
              )
            : _vm._e(),
          _vm._l(_vm.guidanceData, function (item, index) {
            return _c(
              "div",
              {
                staticStyle: {
                  width: "250px",
                  margin: "20px",
                  position: "relative",
                  cursor: "pointer",
                },
                on: {
                  click: function ($event) {
                    return _vm.goComplte(item, index)
                  },
                },
              },
              [
                item.completed
                  ? _c(
                      "el-tag",
                      {
                        staticClass: "guidance-status",
                        attrs: { size: "small", type: "success" },
                      },
                      [_vm._v("已完成")]
                    )
                  : _vm._e(),
                !item.completed
                  ? _c(
                      "el-tag",
                      {
                        staticClass: "guidance-status",
                        attrs: { size: "small", type: "danger" },
                      },
                      [_vm._v("未完成")]
                    )
                  : _vm._e(),
                _c("el-card", { key: index, staticClass: "box-card" }, [
                  _c("div", { staticClass: "guidance-main" }, [
                    item.type == "pdf"
                      ? _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: {
                              height: "100",
                              "p-id": "5448",
                              t: "1671761349703",
                              version: "1.1",
                              viewBox: "0 0 1024 1024",
                              width: "100",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.217 637.256c-15.174-0.489-31.314 0.67-49.65 2.964-24.298-14.987-40.654-35.582-52.274-65.827 0.28-1.152 0.86-3.538 1.063-4.38 0.474-1.958 0.867-3.594 1.243-5.185 4.293-18.13 6.615-31.358 7.3-44.695 0.518-10.074-0.04-19.368-1.827-27.976-3.298-18.584-16.454-29.453-33.021-30.126-15.446-0.627-29.649 7.993-33.281 21.373-5.913 21.612-2.45 50.07 10.08 98.582-15.964 38.056-37.052 82.661-51.203 107.539-18.885 9.74-33.604 18.605-45.953 28.427-16.303 12.966-26.48 26.29-29.286 40.306-1.355 6.48 0.692 14.966 5.36 21.912 5.296 7.879 13.282 12.991 22.855 13.735 24.152 1.877 53.83-23.024 86.59-79.258 3.295-1.09 6.78-2.257 11.026-3.69 2.323-0.783 10.464-3.538 11.91-4.026 7.521-2.54 12.98-4.36 18.376-6.116 23.396-7.612 41.096-12.429 57.21-15.163 27.973 14.973 60.316 24.796 82.098 24.796 17.979 0 30.126-9.319 34.515-23.985 3.857-12.886 0.794-27.824-7.473-36.084-8.56-8.41-24.3-12.434-45.658-13.123z m-247.985 128.42v-0.36l0.126-0.338c1.275-3.421 3.157-7.008 5.6-10.758 4.284-6.576 10.173-13.5 17.472-20.865 3.92-3.955 8.002-7.8 12.79-12.12 1.073-0.969 7.91-7.059 9.189-8.25l11.176-10.407-8.12 12.934c-12.326 19.638-23.46 33.78-33.013 43.004-3.507 3.387-6.6 5.9-9.091 7.505-1.027 0.662-1.916 1.144-2.613 1.424-0.409 0.163-0.771 0.268-1.13 0.302a2.202 2.202 0 0 1-1.117-0.16 2.068 2.068 0 0 1-1.269-1.911z m125.934-218.269l-2.26 4.007-1.39-4.385c-3.114-9.829-5.387-24.641-6.016-37.997-0.716-15.197 0.49-24.323 5.286-24.323 6.74 0 9.831 10.808 10.076 27.053 0.216 14.28-2.03 29.142-5.696 35.645z m-5.81 58.464l1.534-4.05 2.088 3.795c11.69 21.245 26.858 38.967 43.538 51.315l3.595 2.662-4.38 0.904c-16.328 3.372-31.544 8.457-52.34 16.842 2.174-0.876-21.623 8.863-27.638 11.169l-5.252 2.013 2.802-4.877c12.35-21.496 23.758-47.326 36.052-79.773z m157.626 76.261c-7.864 3.104-24.777 0.329-54.569-12.387l-7.561-3.227 8.199-0.607c23.295-1.724 39.807-0.44 49.422 3.08 4.09 1.498 6.824 3.388 8.037 5.553 1.31 2.336 0.71 4.81-1.362 6.31-0.448 0.427-1.155 0.88-2.166 1.278z",
                                fill: "#6f74d1",
                                "p-id": "5449",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    item.type == "mp4"
                      ? _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: {
                              height: "100",
                              "p-id": "10582",
                              t: "1671761618887",
                              version: "1.1",
                              viewBox: "0 0 1024 1024",
                              width: "100",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M821 242.9H205.5c-14.4-0.1-28.2 5.5-38.4 15.6s-15.9 23.9-15.9 38.2v434.9c0.2 29.9 24.4 54.1 54.3 54.3H821c14.4 0.1 28.2-5.5 38.4-15.6s15.9-23.9 15.9-38.2V296.8c-0.5-29.8-24.6-53.7-54.3-53.9zM196.5 469.2h98.3v90.5h-98.3v-90.5z m143.5-181h332.1v452.5H340V288.2z m377.3 181H830v90.5H717.3v-90.5zM830 324.4V424H717.3V288.2h76.9c19.9 0.2 35.8 16.3 35.8 36.2z m-597.8-36.2h62.5V424h-98.3v-99.6c0.1-19.9 16-36 35.8-36.2z m-35.7 416.3v-99.6h98.3v135.8h-62.5c-19.9-0.2-35.8-16.4-35.8-36.2z m597.8 36.2h-76.9V604.9H830v99.6c0 19.8-15.9 36-35.7 36.2z",
                                fill: "#81b337",
                                "p-id": "10583",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M593.9 494.5l-120.8-60.6c-11.3-5.4-19.9 0-19.9 12.2v136.7c0 12.2 9.1 17.6 20.4 12.2l102.7-51.1 17.7-9.1c21.6-10.9 22.1-29-0.1-40.3z",
                                fill: "#81b337",
                                "p-id": "10584",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "guidance-bottom" }, [
                      _c("span", { staticClass: "guidance-name" }, [
                        _vm._v(_vm._s(item.name || "")),
                      ]),
                      _c("span", { staticClass: "guidance-remark" }, [
                        _vm._v(_vm._s(item.remark || "")),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "guidance-info",
                          staticStyle: { "margin-top": "12px" },
                        },
                        [_vm._v("格式：" + _vm._s(item.type || ""))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "guidance-info",
                          staticStyle: { "margin-top": "4px" },
                        },
                        [
                          _vm._v(
                            "最后修改时间：" + _vm._s(item.updateTime || "")
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.nowData.name,
            top: "5vh",
            visible: _vm.lookFlag,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.lookFlag = $event
            },
          },
        },
        [
          _c("div", { staticClass: "look-content" }, [
            _vm.nowData.type != "mp4"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-alert",
                      { attrs: { closable: false, type: "warning" } },
                      [_vm._v("请滑动鼠标至底部，阅读并确认全部内容")]
                    ),
                    _vm._l(_vm.numPages, function (i) {
                      return _c("pdf", {
                        key: i,
                        attrs: { page: i, src: _vm.nowData.file },
                      })
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.nowData.type == "mp4"
              ? _c("video", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    id: "video",
                    src: _vm.nowData.file,
                    autoplay: "",
                    controls: "",
                  },
                })
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticStyle: { display: "flex", "justify-content": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.lookFlag = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }